<script>
    import { onMount } from "svelte";

    import {
        getNumber,
        getRatioPercentageValue,
        isObjectEmpty,
        splitCamelCase,
    } from "../../../Utils/utilFunctions.svelte";

    import { CustomTooltip } from "../../../Components/Common/index.svelte";

    import PieChart from "../../../Components/Charts/PieChart.svelte";

    export let dashboardData = {},
        filters = {};

    let isParsingData = true,
        chartData = [],
        chartLabels = [];

    let chartColors = [
        "rgba(251, 60, 186, 0.8)",
        "rgba(251, 212, 8, 1)",
        "rgba(7, 208, 3, 1)",
        "rgba(20, 184, 194, 1)",
        "rgba(97, 20, 194, 1)",
        "rgba(20, 90, 194, 1)",
        "rgba(30, 40, 130, 1)",
    ];

    onMount(() => {
        if (dashboardData && !isObjectEmpty(dashboardData))
            syncEncountersData(dashboardData);
        else isParsingData = false;
    });

    const syncEncountersData = (data) => {
        const { totalEncoutnersByInsurance } = data;

        if (
            !totalEncoutnersByInsurance ||
            isObjectEmpty(totalEncoutnersByInsurance)
        ) {
            isParsingData = false;
            return;
        }

        const entries = Object.entries(totalEncoutnersByInsurance);

        let sumInsurances = 0;

        for (const [key, value] of entries) {
            sumInsurances += value;
        }

        for (const [key, value] of entries) {
            chartLabels = [...chartLabels, `${splitCamelCase(key)} (${value})`];
            chartData = [
                ...chartData,
                getRatioPercentageValue(value, sumInsurances),
            ];
        }

        isParsingData = false;
    };
</script>

<div class="flex flex-col flex-1 gap-4 p-4">
    <div class="flex flex-1 items-center gap-x-4">
        <div class="flex flex-1 flex-col border rounded-lg p-2">
            <div class="flex flex-1 items-start gap-x-2">
                <div class="flex flex-1 flex-col gap-y-2">
                    <p class="text-md">Cases</p>
                    <p class="font-bold text-md">
                        {getNumber(dashboardData?.totalEncounters)}
                    </p>
                </div>

                <CustomTooltip zIndex="10">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        class="stroke-current shrink-0 w-4 h-4"
                        slot="tooltipTrigger"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>

                    <div>
                        <p>
                            These are all your active encounters grouped by
                            Insurance Type in the defined period.
                        </p>
                        <p>Excludes archived encounters.</p>
                    </div>
                </CustomTooltip>
            </div>
        </div>

        <div class="flex flex-1 flex-col border rounded-lg p-2">
            <div class="flex flex-1 items-start gap-x-2">
                <div class="flex flex-1 flex-col gap-y-2">
                    <p class="text-md">Cases awaiting payment</p>
                    <p class="font-bold text-md">
                        {getNumber(dashboardData?.totalOpenEncounters)}
                    </p>
                </div>

                <CustomTooltip zIndex="10">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        class="stroke-current shrink-0 w-4 h-4"
                        slot="tooltipTrigger"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>

                    <div>
                        <p>
                            These are all your active encounters that are
                            currently "submitted" or "in progress" in the
                            defined period.
                        </p>
                        <p>Excludes any archived ones.</p>
                    </div>
                </CustomTooltip>
            </div>
        </div>
    </div>

    <div class="flex flex-1 flex-col gap-y-2">
        <div class="flex w-full items-center gap-x-2">
            <p class="font-bold text-md">Encounters</p>

            <CustomTooltip zIndex="10">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    class="stroke-current shrink-0 w-4 h-4"
                    slot="tooltipTrigger"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                </svg>

                <p>
                    These are all your encounters grouped by Insurance Type in
                    the defined period.
                </p>
            </CustomTooltip>
        </div>

        {#if isParsingData}
            <div class="flex flex-1 items-center text-center">
                Parsing chart data
            </div>
        {:else if !chartData.length}
            <div class="flex flex-1 items-center text-center">
                No encounters added, nothing to display
            </div>
        {:else}
            <PieChart
                isResponsive={false}
                width="50"
                height="150px"
                backgroundColorArr={chartColors}
                {chartData}
                labels={chartLabels}
            />
        {/if}
    </div>
</div>
